import {combineReducers} from 'redux';
import homeDataStepView from './homeDataStepView';
import calculatorStepView from './calculatorStepView';
import personalDataStepView from './personalDataStepView';
import workDataStepView from './workDataStepView';

const uiReducer = combineReducers({
    calculatorStepView,
    homeDataStepView,
    personalDataStepView,
    workDataStepView
});

export default uiReducer;